import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(({ palette }) => ({
  index: {
    '& span': {
      width: 32,
      height: 32,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 4,
      backgroundColor: palette.cncUI.default['+8'],
      color: palette.cncUI.default.primary,
      fontSize: 16,
      lineHeight: '22px',
    },
  },
  description: {
    flexGrow: 1,
  },
}));

const Step = ({ index, children }) => {
  const classes = useStyles();
  return (
    <Grid container spacing={2} alignItems="center" direction="row">
      <Grid item className={classes.index}>
        <span>{index}</span>
      </Grid>
      <Grid item xs={10} className={classes.description}>
        {children}
      </Grid>
    </Grid>
  );
};

export default Step;
